import React, { Fragment } from "react";
import { Breadcrumbs, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MaterialTable from "../../../components/material_table";
import { ACTUALIZAR_GERENCIA, AGREGAR_GERENCIA, ELIMINAR_GERENCIA } from "../../../constants/permissions";

function Page(props) {
	const {
		usuario,
		gerencias,
		dialog_open,
		handle_show_dialog,
		handle_eliminar,
		handle_cancelar,
		handle_export,
	} = props;

	const history = useHistory();
	const permisos = Array.from(usuario.permisos);
	const permisoActualizar = permisos.find(p => p.nombre === ACTUALIZAR_GERENCIA);
	const permisoAgregar = permisos.find(p => p.nombre === AGREGAR_GERENCIA);
	const permisoEliminar = permisos.find(p => p.nombre === ELIMINAR_GERENCIA);

	let columns = [
		{
			title: "Nombre",
			field: "nombre",
		}, {
			title: "Sigla",
			field: "sigla",
		}, {
			title: "Responsable",
			field: "responsable_ref.persona.nombre_completo",
		}
	];

	let actions = [
		{
			icon: "edit",
			tooltip: "Editar",
			onClick: (event, row) => history.push(`/gerencia/${row._id}`),
			iconProps: { style: { color: permisoActualizar ? "#757575" : null } },
			// hidden: !permisoActualizar,
			disabled: !permisoActualizar,
		}, {
			icon: "delete",
			tooltip: "Eliminar",
			onClick: (event, row) => handle_show_dialog(row._id),
			iconProps: { style: { color: permisoEliminar ? "#757575" : null } },
			// hidden: !permisoEliminar,
			disabled: !permisoEliminar,
		}, {
			icon: "add",
			tooltip: "Agregar",
			onClick: () => history.push("/gerencia"),
			isFreeAction: true,
			// hidden: !permisoAgregar,
			disabled: !permisoAgregar,
		},
	];

	return (
		<Fragment>
			<Breadcrumbs separator=">">
				<Typography color="textPrimary">Módulo Gerencias</Typography>
				<Typography color="textPrimary">Listado Gerencias</Typography>
			</Breadcrumbs>
			<MaterialTable
				title="Listado de Gerencias"
				data={gerencias}
				is_loading={!gerencias}
				columns={columns}
				actions={actions}
				export_function={handle_export}
			/>
			<Dialog
				open={dialog_open}
				disableBackdropClick
				disableEscapeKeyDown
			>
				<DialogTitle>Eliminar Gerencia</DialogTitle>
				<DialogContent dividers>
					<Typography>Se debe confirmar la eliminación de la gerencia.</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handle_eliminar} variant="contained" color="primary">Eliminar</Button>
					<Button autoFocus onClick={handle_cancelar} color="primary">Cancelar</Button>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
}

export default Page;